import ModalHtml from './ModalHtml';
import ModalVideo from './ModalVideo';

const initModal = () => {
  if(document.getElementsByClassName('open-modal').length > 0) {
    let body = document.getElementsByTagName('body')[0];
    let modalNode =  document.createElement('div');
    modalNode.classList.add('modal');
    let modalInnerNode =  document.createElement('div');
    modalInnerNode.classList.add('modal-inner');
    let backdropNode = document.createElement('div');
    backdropNode.classList.add('modal-backdrop');
    let closeIconNode = document.createElement('a');
    closeIconNode.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"width="63px" height="61.9px" viewBox="0 0 63 61.9">
        <path d="M2.5,59.2l2.1,2.1l27.6-27.6l0.1,0.1l26.2,26.2l2.1-2.1L34.2,31.6l0.1-0.1L61.8,4l-2.1-2.1L32.2,29.5l-0.1-0.1L3.2,0.6
          L1.2,2.7l28.9,28.9L30,31.7L2.5,59.2z"/>
        <polygon class="st0" points="70.1,15.2 67.3,17.8 69,20 71.6,17.5 "/>
      </svg>`;
    modalNode.appendChild(closeIconNode);
    modalNode.appendChild(modalInnerNode);
    body.appendChild(modalNode);
    body.appendChild(backdropNode);
    let openModalButtons = document.getElementsByClassName('open-modal');
    for(let openModalButton of openModalButtons) {
      let contentType = openModalButton.getAttribute('data-content-type') ? openModalButton.getAttribute('data-content-type'): 'html';
      if (contentType === 'video') {
        new ModalVideo(openModalButton, modalNode, modalInnerNode, backdropNode, closeIconNode);
      }
      else {
        new ModalHtml(openModalButton, modalNode, modalInnerNode, backdropNode, closeIconNode);
      }
    }
  }
}

initModal();


// WEBPACK FOOTER //
// ./ui/assets/js/Modal/init.js